import { Flex, Text } from '@chakra-ui/react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { FormFeedback } from '@morressier/alembic';
import { FieldLabel } from 'src/components/Field';
import FieldAutoSuggestSelect from '../../FieldSearchSelect';
import { FieldFormValues } from '../../../helpers/articleTypeConfig.types';
import { formatKeyPath } from '../../../helpers/articleTypeConfig.utils';

type Props = {
  mode: 'add' | 'edit';
  control: Control<FieldFormValues>;
  errors: FieldErrors<FieldFormValues>;
  sourceFieldNames: string[];
  fieldValue?: string;
};

const SourceFieldSection: React.FC<Props> = ({
  mode,
  control,
  errors,
  sourceFieldNames,
  fieldValue
}) => {
  return (
    <Flex direction="column" gap={2} flex={1}>
      <FieldLabel label="Field" subText="" isRequired={mode === 'add'} />

      {mode === 'add' ? (
        <Controller
          name="sourceFieldName"
          control={control}
          rules={{
            required: 'Please select a field',
            validate: value =>
              (Boolean(value?.trim()) && sourceFieldNames.includes(value)) ||
              'Please select a field'
          }}
          render={({ field }) => (
            <FieldAutoSuggestSelect
              value={field.value}
              options={sourceFieldNames}
              onSelect={field.onChange}
              isInvalid={Boolean(errors.sourceFieldName)}
            />
          )}
        />
      ) : (
        <Text textStyle="textBody">
          {fieldValue ? formatKeyPath(fieldValue) : '-'}
        </Text>
      )}

      {mode === 'add' && errors.sourceFieldName ? (
        <FormFeedback variant="error">
          {errors.sourceFieldName.message}
        </FormFeedback>
      ) : null}
    </Flex>
  );
};

export default SourceFieldSection;
